import { CSSProperties } from 'react';
import { PlacementType, VariantType } from '../types';

interface ArrowPosition {
  top: number;
  left: number;
}

/**
 * Gets the style for the arrow element based on placement, position and variant
 */
export const getArrowStyle = (
  placement: PlacementType,
  arrowPosition: ArrowPosition,
  variant: VariantType = 'black'
): CSSProperties => {
  const getBackgroundColor = (variant: VariantType): string => {
    switch (variant) {
      case 'black':
        return 'rgb(17, 17, 17)';
      case 'teal':
        return 'rgb(72, 166, 171)';
      case 'orange':
        return ' #DE7C00';
      default:
        return 'rgb(17, 17, 17)';
    }
  };

  const base: CSSProperties = {
    position: 'absolute',
    width: '8px',
    height: '8px',
    background: getBackgroundColor(variant),
    transform: 'rotate(45deg)',
  };
  
  if (placement.startsWith('top')) {
    return {
      ...base,
      bottom: '-4px',
      left: `${arrowPosition.left}px`,
      marginLeft: '-4px',
    };
  } else if (placement.startsWith('right')) {
    return {
      ...base,
      left: '-4px',
      top: `${arrowPosition.top}px`,
      marginTop: '-4px',
    };
  } else if (placement.startsWith('bottom')) {
    return {
      ...base,
      top: '-4px',
      left: `${arrowPosition.left}px`,
      marginLeft: '-4px',
    };
  } else if (placement.startsWith('left')) {
    return {
      ...base,
      right: '-4px',
      top: `${arrowPosition.top}px`,
      marginTop: '-4px',
    };
  }
  
  return base;
}; 